"use client";

import Link from "next/link";
import Image from "next/image";
import { CalendarIcon } from "@heroicons/react/20/solid";

interface Props {
  landingPage: {
    Name: string;
    Url: string;
    Header: string;
    Footer: string;
    Region: string;
    Date: { Start: string | null; End: string | null; Range: string | null };
    Images: {
      BannerSmall: string;
      DefaultSmall: string;
      Landingpage: string;
      Portrait: string;
    };
  };
}

export default function LandingPageLink({ landingPage }: Props) {
  return (
    <Link
      href={landingPage.Url}
      className="flex flex-col gap-1 hover:bg-indigo-50/75 p-2 min-w-50 rounded-2xl transition-colors ease-in-out duration-500"
    >
      <div className="relative">
        <Image
          src={landingPage.Images.Landingpage.trim()}
          alt={landingPage.Name}
          width={920}
          height={220}
          className="object-cover w-full aspect-46/11 rounded-xl"
        />

        {landingPage.Date.Start && (
          <span className="flex gap-0.5 items-center absolute bottom-2 right-2 p-1 rounded-lg text-sm bg-indigo-100 text-indigo-800">
            <CalendarIcon className="h-4 w-4" />
            {landingPage.Date.Start}
          </span>
        )}
      </div>
      <p className="text-lg font-semibold text-black">{landingPage.Name}</p>
    </Link>
  );
}
